import React from "react";
import { CopyToClipboard } from "react-copy-to-clipboard/lib/Component";
import { getServiceNameWithNickname } from "../../../../utils/getServiceNameWithNickname";
import { TimestampToDateMoment } from "../../../../utils/timestampToDate";
import PageSpinner from "../../../elements/spinner/PageSpinner";

import { StyledConnectionLogo } from "../../../elements/connection/styledConnection";
import { StyledBreakWord } from "../../../styles/styledBreakWord";
import { StyledCopy } from "../../../styles/styledCopy";
import { StyledCol, StyledTable, StyledTableBody, StyledTableHead, StyledTableRow } from "../../../styles/styledTable";
import { StyledBlockLabel, StyledFormBlock, StyledFormGrid } from "../../../styles/styledTabsForm";
import { StyledMasterRefillingsDetailsContent } from "../../styledMasterRefillings";

const MasterRefillingsDetailsContent = ({ t, refilling, setNotification }) => {

  if (!refilling) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  return (
    <StyledMasterRefillingsDetailsContent>
      <StyledFormGrid className="refiling-details-content">
        <StyledFormBlock className="refiling-details-content__block">
          <StyledBlockLabel>
            {t("details.title")}
          </StyledBlockLabel>
          <StyledTable size="14">
            <StyledTableHead col="2" className="refiling-details-content__head">
              <StyledCol>{t("key")}:</StyledCol>
              <StyledCol>{t("value")}:</StyledCol>
            </StyledTableHead>
            <StyledTableBody>
              <StyledTableRow col="2" className="refiling-details-content__row">
                <StyledCol data-title={t("key")}>
                  ID
                </StyledCol>
                <StyledCol data-title={t("value")}>
                  <div>
                    <CopyToClipboard
                      text={refilling.id}
                      onCopy={() => {
                        setNotification((prev) => ({
                          ...prev,
                          visible: true,
                          type: "success",
                          message: t("table.copied")
                        }));
                      }}
                    >
                      <StyledBreakWord as="p">
                        {refilling.id} <StyledCopy
                        title={t("table.copy")}
                        className="icon-light-copy"
                      />
                      </StyledBreakWord>
                    </CopyToClipboard>
                  </div>
                </StyledCol>
              </StyledTableRow>
              <StyledTableRow col="2" className="refiling-details-content__row">
                <StyledCol data-title={t("key")}>
                  {t("details.amount")}
                </StyledCol>
                <StyledCol data-title={t("value")}>
                  <div>
                    <p>{refilling.amount} {refilling.masterBalance.currency.asset}</p>
                  </div>
                </StyledCol>
              </StyledTableRow>
              <StyledTableRow col="2" className="refiling-details-content__row">
                <StyledCol data-title={t("key")}>
                  {t("details.service")}
                </StyledCol>
                <StyledCol data-title={t("key")} className="service">
                  <div>
                    <p>{getServiceNameWithNickname(refilling.masterBalance.service.name, refilling.masterBalance.service.nickname)}</p>
                  </div>
                  <StyledConnectionLogo
                    icon={refilling.masterBalance.service.name}
                    className="service__icon"
                  />
                </StyledCol>
              </StyledTableRow>
              <StyledTableRow col="2" className="refiling-details-content__row">
                <StyledCol data-title={t("key")}>
                  {t("details.user")}
                </StyledCol>
                <StyledCol data-title={t("value")}>
                  <div>
                    <p>{refilling.user.email}</p>
                  </div>
                </StyledCol>
              </StyledTableRow>
              <StyledTableRow col="2" className="refiling-details-content__row">
                <StyledCol data-title={t("key")}>
                  {t("details.createdAt")}
                </StyledCol>
                <StyledCol data-title={t("value")}>
                  <div>
                    <p>{TimestampToDateMoment(refilling.createdAt)}</p>
                  </div>
                </StyledCol>
              </StyledTableRow>
            </StyledTableBody>
          </StyledTable>
        </StyledFormBlock>
      </StyledFormGrid>
    </StyledMasterRefillingsDetailsContent>
  );
};

export default MasterRefillingsDetailsContent;